<template>
  <div class="fill-height">
    <div class="fill-height">
      <v-card
        max-width="600"
        class="mx-auto"
        style="height: 80%; position: relative;"
      >
        <v-card-text style="height: 100%">
          <p class="text-h4 text--primary text-center mt-10">
            {{ playingInfo.title }}
          </p>
        </v-card-text>
        <div style="position: absolute; bottom: 0px; width: 100%;">
          <v-row>
            <v-col cols="4" class="text-center pb-0">
              <v-btn block text @click="skipPrevious">
                <v-icon>mdi-skip-previous</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="4" class="text-center pb-0">
              <v-btn block text @click="togglePlay">
                <v-icon x-large>{{
                  playing ? "mdi-pause" : "mdi-play"
                }}</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="4" class="text-center pb-0">
              <!-- Display next button as a column with icon row and text row -->
              <v-btn block text @click="skipNext">
                <v-icon top>mdi-skip-next</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="text-center pt-0 caption">
              Repeat
            </v-col>
            <v-col cols="4" class="text-center pt-0 caption"> </v-col>
            <v-col cols="4" class="text-center pt-0 caption">
              I know this
            </v-col>
          </v-row>
        </div>
      </v-card>
    </div>
    <v-dialog :value="noMoreItemsDialogVisible" max-width="390">
      <v-card>
        <v-card-title class="headline">No more items to review 🎉</v-card-title>

        <v-card-text>
          <p>
            You've studied everything that was scheduled from this list for
            today.
          </p>
          <p><strong>Well done!</strong></p>
          <p>
            In order to learn new things efficiently you need to take a brake.😴
          </p>
          <p>Please come back tomorrow for the next session.</p>
          <div v-if="!loggedIn">
            <v-divider></v-divider>
            <div class="mt-6 text-center">
              <h2 class="text-h6">Don't lose your progress!</h2>
              <v-btn
                x-large
                depressed
                color="primary"
                class="mt-6"
                href="/accounts/signup"
              >
                Sign up for free
              </v-btn>
              <div class="mt-6">
                Already have an account? <a href="/account/login">Log in</a>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions v-if="loggedIn">
          <v-btn color="primary" text @click="hideNoMoreItemsDialog"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showSignUpDialog" max-width="390">
      <v-card>
        <v-card-title
          style="justify-content: center; flex-direction: column; word-break: normal;"
          class="headline"
        >
          <div style="font-size: 4rem; margin-top: 2rem;">📈</div>
          <div style="margin-top: 2.7rem; text-align: center;">
            Don't lose your progress!
          </div>
        </v-card-title>

        <v-card-text>
          <div class="text-center">
            <v-btn
              x-large
              depressed
              color="primary"
              class="mt-6"
              href="/accounts/signup"
            >
              Sign up for free
            </v-btn>
            <div class="mt-3">It takes less than 30 seconds.</div>

            <div class="mt-6">
              Already have an account? <a href="/account/login">Log in</a>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions v-if="loggedIn">
          <v-btn color="primary" text @click="hideNoMoreItemsDialog"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PlayerService from "@/common/player.service";

export default {
  name: "Player",

  computed: {
    ...mapGetters([
      "playerVisible",
      "playing",
      "playingInfo",
      "noMoreItemsDialogVisible",
      "signupToKeepProgressVisible",
      "loggedIn",
    ]),
    showSignUpDialog: {
      get() {
        return this.signupToKeepProgressVisible;
      },
      set(newValue) {
        return this.$store.dispatch("displaySignupToKeepProgress", newValue);
      },
    },
  },

  methods: {
    ...mapActions(["togglePlay", "hideNoMoreItemsDialog"]),
    skipPrevious() {
      PlayerService.previous();
    },
    skipNext() {
      PlayerService.next();
    },
    ignore() {
      PlayerService.ignore();
    },
  },
};
</script>
